/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Workout_Dots_LabelInputs */

const en_us2_workout_dots_label = /** @type {(inputs: Workout_Dots_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} of 1 set done`);
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.total} sets done`)
	
};

const pt_br2_workout_dots_label = /** @type {(inputs: Workout_Dots_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 série feita`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} séries feitas`)
	
};

const es_419_workout_dots_label = /** @type {(inputs: Workout_Dots_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 serie hecha`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} series hechas`)
	
};

const pt_pt2_workout_dots_label = /** @type {(inputs: Workout_Dots_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 série feita`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.total} séries feitas`)
	
};

const fr_fr2_workout_dots_label = /** @type {(inputs: Workout_Dots_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} série sur 1 faite`);
	return /** @type {LocalizedString} */ (`${i?.done} séries sur ${i?.total} faites`)
	
};

const de_de2_workout_dots_label = /** @type {(inputs: Workout_Dots_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} von 1 Satz erledigt`);
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.total} Sätzen erledigt`)
	
};

const it_it2_workout_dots_label = /** @type {(inputs: Workout_Dots_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`${i?.done} di 1 serie fatta`);
	return /** @type {LocalizedString} */ (`${i?.done} di ${i?.total} serie fatte`)
	
};

/**
* | total | output |
* | --- | --- |
* | "1" | "{done} of 1 set done" |
* | * | "{done} of {total} sets done" |
*
* @param {Workout_Dots_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_dots_label = /** @type {((inputs: Workout_Dots_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Dots_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_dots_label(inputs)
	if (locale === "es-419") return es_419_workout_dots_label(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_dots_label(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_dots_label(inputs)
	if (locale === "de-DE") return de_de2_workout_dots_label(inputs)
	if (locale === "it-IT") return it_it2_workout_dots_label(inputs)
	return en_us2_workout_dots_label(inputs)
});
export { workout_dots_label as "workout.dots_label" }